module.exports = __webpack_public_path__ + "static/media/bg.db5270d9.jpg";